import React, { useState } from "react";
import "./ContactUs.css";
import { Container, Row, Col, Form } from "react-bootstrap";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { isValidPhoneNumber } from "react-phone-number-input";
import fr from "react-phone-number-input/locale/fr";
import en from "react-phone-number-input/locale/en";
import addressIcon from "../../assets/images/address.svg";
import emailIcon from "../../assets/images/email.svg";
import phoneIcon from "../../assets/images/ic_baseline-phone.svg";

import contactImg from "../../assets/images/contactImg.png";
import { useTranslation } from "../../contexts/TranslationContext";

const ContactUs = ({ url, contactSection, translations, language ,pageData}) => {
  const { t } = useTranslation();
  const [phoneError, setPhoneError] = useState("");
 

  const contactData = pageData?.content?.templates?.find(
    (template) => template.section === "Contact Info"
  )?.data;

  const addressHtml = contactData?.address || "";
  const email = contactData?.email || "";
  const phone = contactData?.phone || "";
  const mapSrcHtml = contactData?.map_src || "";

  const address = addressHtml.replace(/<[^>]*>/g, "").trim();
  const mapSrc = mapSrcHtml.replace(/<[^>]*>/g, "").trim();
  



  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    if (e && e.target) {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleChangePhone = (val) => {
    setFormData((prevData) => ({
      ...prevData,
      phoneNumber: val,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!isValidPhoneNumber(formData.phoneNumber || "")) {
      setPhoneError(t("InvalidPhoneNumber"));
      setIsSubmitting(false);
      return;
    } else {
      setPhoneError("");
    }

    const payload = {
      first_name: formData.firstName,
      last_name: formData.lastName,
      email_address: formData.email,
      phone_number: formData.phoneNumber,
      message: formData.message,
    };

    try {
      const response = await fetch(
        `${url}/api/method/alltimes.alltimes_travel.doctype.contact_us.contact_us.create_contact_us`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        setIsSubmitted(true);
      } else {
        alert(t("failedToSendMessage"));
      }
    } catch (error) {
      alert(t("anErrorOccurred"));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-us">
      <Container className="cotact-us-container">
        <Row data-aos="fade-right" data-aos-duration="2300">
          <Col lg={7}>
            <div className="page-name">
              {" "}
              {t("Home")} /{" "}
              <span style={{ fontWeight: "700" }}> {t("ContactUs")}</span>{" "}
            </div>
            <div className="contact-intro">
              <div className="title-contact">
                {" "}
                {t("DreamVacationDestination")}
              </div>
              <div className="get-touch"> {t("GetInTouch")}</div>
              <div className="contact-text">{t("GetTouchText")}</div>
            </div>

            <div className=" contact-info contact-info-text">
            
                  <div style={{ display:"flex" , alignItems:"flex-start" , width:"90%"}}>
                    <img className="contact-icon" src={addressIcon} alt="" />
                    <span>
                      {address ? address : "address 1/ address 2"}
                      </span>
                  </div>
             
             
                  <div>
                    <img className="contact-icon" src={emailIcon} alt="" />
                    <span>{email ? email : "test@gmail.com"}</span>
                  </div>
            
           
                  <div>
                    <img className="contact-icon" src={phoneIcon} alt="" />
                    <span>{phone ? phone : "000000000"}</span>
                  </div>
            
            
            </div>
            {/* <img className="contact-img" src={contactImg} alt=""></img> */}
            <iframe  src={mapSrc} width="100%" height="290"   style={{ border: 0 }}  allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </Col>
          <Col lg={5}>
            {isSubmitted ? (
              <div className="success-message">
                <h2>{t("thankYou")}</h2>
                <p>{t("messageSentSuccessfully")}</p>
              </div>
            ) : (
              <Form
                className="contact-form"
                onSubmit={handleSubmit}
                style={{ opacity: isSubmitting ? 0.5 : 1 }}
              >
                <div className="contact-input">
                  <p className="contact-input-title">{t("FirstName")}</p>
                  <input
                    type="text"
                    className="contact-input-text"
                    placeholder={t("FirstName")}
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    required
                  />
                </div>
                <div className="contact-input">
                  <p className="contact-input-title">{t("LastName")}</p>
                  <input
                    type="text"
                    className="contact-input-text"
                    placeholder={t("LastName")}
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    required
                  />
                </div>
                <div className="contact-input">
                  <p className="contact-input-title">{t("EmailAddress")}</p>
                  <input
                    type="email"
                    className="contact-input-text"
                    placeholder={"yourName@email.com"}
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    required
                  />
                </div>
                <div className="contact-input">
                  <p className="contact-input-title">{t("PhoneNumber")}</p>
                  <PhoneInput
                    placeholder={t("ُEnterPhoneNumber")}
                    name="phoneNumber"
                    labels={language == "fr" ? fr : en}
                    value={formData.phoneNumber}
                    onChange={(value) => handleChangePhone(value)}
                    country={undefined}
                    defaultCountry={"US"}
                    international={true}
                    className="contact-input-text"
                    disabled={isSubmitting}
                    required
                  />
                  {phoneError && (
                    <div className="invalid-feedback d-block">{phoneError}</div>
                  )}
                </div>

                <div className="contact-input">
                  <p className="contact-input-title">{t("Message")}</p>
                  <textarea
                    rows={"5"}
                    className="contact-input-text"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    required
                  ></textarea>
                </div>
                <div>
                  <input
                    type="submit"
                    value={t("Send")}
                    disabled={isSubmitting}
                    className="contact-submit"
                  />
                </div>
              </Form>
            )}
          </Col>
        </Row>
      </Container>
      {/* {!isSubmitted && (
        <div>
          <img
            className="contact-us-img"
            src={ contact_us_img?(url+"/"+contact_us_img): require("../../assets/images/contactImg.png")}
            alt=""
          />
          <Container className="contact-us-img-responsive">
            <img src={ contact_us_img?(url+"/"+contact_us_img): require("../../assets/images/contactImg.png")} alt="" />
          </Container>
        </div>
      )} */}
    </div>
  );
};

export default ContactUs;
